// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The geometry or data type contained in a file layer.
 *
 * Geometry values mirror GeoJSON / OGC SFA types so they map directly to
 * vector layer geometry types.  ``RASTER`` covers grid/raster result layers
 * (e.g. scenario simulation outputs).
 * @export
 */
export const NormalisedLayerType = {
  Point: "Point",
  LineString: "LineString",
  Polygon: "Polygon",
  MultiPoint: "MultiPoint",
  MultiLineString: "MultiLineString",
  MultiPolygon: "MultiPolygon",
  GeometryCollection: "GeometryCollection",
  Raster: "raster",
} as const;
export type NormalisedLayerType = (typeof NormalisedLayerType)[keyof typeof NormalisedLayerType];

export function instanceOfNormalisedLayerType(value: any): boolean {
  for (const key in NormalisedLayerType) {
    if (Object.prototype.hasOwnProperty.call(NormalisedLayerType, key)) {
      if (NormalisedLayerType[key as keyof typeof NormalisedLayerType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function NormalisedLayerTypeFromJSON(json: any): NormalisedLayerType {
  return NormalisedLayerTypeFromJSONTyped(json, false);
}

export function NormalisedLayerTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): NormalisedLayerType {
  return json as NormalisedLayerType;
}

export function NormalisedLayerTypeToJSON(value?: NormalisedLayerType | null): any {
  return value as any;
}

export function NormalisedLayerTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): NormalisedLayerType {
  return value as NormalisedLayerType;
}
